import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import BrandShine from '../../../components/BrandShine';
import Beauty from "../../../assets/Mobeaulity/Beauty.png";
import Beauty2 from "../../../assets/Mobeaulity/Beauty2.png";
import Beauty5 from "../../../assets/Mobeaulity/Beauty5.png";
import Beauty7 from "../../../assets/Mobeaulity/Beauty7.png";
import Beauty9 from "../../../assets/Mobeaulity/Beauty9.png";
import Beauty11 from "../../../assets/Mobeaulity/Beauty11.jpeg";
import Beauty12 from "../../../assets/Mobeaulity/Beauty12.png"; 
import Beauty13 from "../../../assets/Mobeaulity/Beauty13.jpeg";
import Beauty14 from "../../../assets/Mobeaulity/Beauty14.png";
import TestimonialImage from "../../../assets/Mobeaulity/Beauty10.jpg"; 
import { Helmet } from "react-helmet";

function Mobeaulity() {
<Helmet>
  <title>Mobeaulity Beauty Brand Website | Woaom Web Design</title>
  <meta
    name="description"
    content="Discover the Mobeaulity project — a luxury beauty and wellness brand website designed for women entrepreneurs. Mobile-first, elegant, and built to convert with a seamless booking flow."
  />
  <meta
    name="keywords"
    content="Mobeaulity beauty brand website, luxury beauty business web design, mobile-first beauty brand site, women entrepreneurs beauty websites, custom beauty and wellness site, modern spa and wellness web design, booking website for beauty services, feminine brand web design, clean beauty branding website, women-owned wellness business site, mobile beauty studio web design, brand identity for beauty startups, user-friendly booking flow website, elegant beauty founder website, creative direction for beauty brands, custom wellness brand websites, sleek spa and salon websites, responsive design for beauty entrepreneurs, bold women-led brand websites, spa and wellness founder site, beauty tech brand digital platform, brand-focused web design for wellness, luxury feminine brand web design, beauty and wellness portfolio site, online appointment scheduling websites, strategic web design for beauty professionals, high-converting spa websites, brand glow up for women entrepreneurs, digital platforms for beauty founders, custom websites for wellness brands"
  />
</Helmet>


  return (
    <section className="bg-white">
      <Navbar />

      {/* Hero Image Section */}
      <div className="mx-auto max-w-8xl">
        <img
          src={Beauty9}
          alt="website template for coaches, feminine website template, React website template for service providers, sales page template, course website template, booking website template, Kajabi alternative, custom coded website, React Firebase landing page, website template for wellness brand"
          className="inline-block w-full object-cover"
        />
      </div>

      {/* Project Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Sidebar */}
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-semibold tracking-widest text-gray-800 uppercase">Services</h3>
              <p className="text-gray-700 mt-2">Brand Design </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold tracking-widest text-gray-800 uppercase">Platform</h3>
              <p className="text-orange-500 mt-2">Figma + Adobe XD</p>
            </div>
          </div>

          {/* Project Content */}
          <div className="md:col-span-2 space-y-6">
            <h2 className="text-4xl  font-medium text-gray-900">
              MOBEAULITY
            </h2>
            <h4 className="text-xl font-medium text-gray-700">
              Bright And Retro Brand Design For Black-Owned Beauty Business
            </h4>
            <p className="text-gray-800 leading-relaxed">
              Mobeaulity is the 1st Beauty Supply Airstream — an elevated & streamlined mobile shopping experience for W.o.C. Charity needed unique and colorful branding with a modern retro vibe.
            </p>
            {/* <p className="font-semibold text-sm text-black">
              LIVE SITE:{' '}
              <a
                href="https://mindovermoney.net"
                className="text-orange-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                MindOverMoney.net
              </a>
            </p> */}
          </div>
        </div>

        {/* Testimonial Section */}
        <div className="mt-16 bg-[#f1f6f7] px-6 py-12 rounded-md max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 text-left">
            {/* Circular Image */}
            <div className="flex-shrink-0">
              <img
                src={TestimonialImage}
                alt="waitlist landing page template, email list builder for coaches, launch waitlist template, build email list before launch, email capture website, prelaunch funnel template, flodesk landing page template, convertkit website template, freebie funnel for service business, list-building website template"
                className="w-40 h-40 object-cover rounded-full mt-10"
              />
            </div>
            {/* Quote */}
            <div className="flex-1">
              <div className="text-4xl text-[#3d7b75] mb-4">“</div>
              <p className="text-gray-800 text-xl font-light leading-relaxed">
                Working with Woaom Web Design on the Mobeaulity brand design was an absolute dream! Charity truly understood my vision for an elevated, modern retro vibe for the Beauty Supply Airstream. The final branding is unique, vibrant, and perfectly captures the essence of what Mobeaulity stands for. I couldn't be happier with how they brought my concept to life with such creativity and precision. Highly recommend!
              </p>
              <p className="mt-6 text-[#3d7b75] uppercase tracking-wide text-sm">– Sam L.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="bg-white space-y- pb-20">
        {[Beauty, Beauty11, Beauty14, Beauty12, Beauty2, Beauty5, Beauty7, Beauty13].map((img, i) => (
          <div key={i} className="mx-auto max-w-8xl">
            <img src={img} alt={`Gallery Image ${i + 1}`} className="w-full object-cover" />
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <BrandShine />

      <Footer />
    </section>
  );
}

export default Mobeaulity;
